
<div class="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 to-slate-100 dark:from-slate-900 dark:to-slate-800">
    <div class="max-w-md w-full mx-4">
        <!-- Carte principale -->
        <div class="bg-white dark:bg-slate-800 rounded-2xl shadow-2xl overflow-hidden border border-slate-200 dark:border-slate-700">
            <!-- En-tête avec icône -->
            <div class="bg-gradient-to-r from-main_color to-main_color_2 p-8 text-center">
                <div class="inline-flex items-center justify-center w-20 h-20 bg-white/20 backdrop-blur-sm rounded-full mb-4 animate-pulse">
                    <i class="fas fa-link text-4xl text-white"></i>
                </div>
                <h1 class="text-2xl font-bold text-white">Redirection</h1>
            </div>

            <!-- Contenu -->
            <div class="p-8">
                @if (isLoading) {
                    <!-- Animation de chargement moderne -->
                    <div class="flex flex-col items-center space-y-6">
                        <!-- Spinner avec effet de pulsation -->
                        <div class="relative">
                            <div class="w-16 h-16 border-4 border-main_color/30 rounded-full"></div>
                            <div class="absolute top-0 left-0 w-16 h-16 border-4 border-transparent border-t-main_color rounded-full animate-spin"></div>
                        </div>

                        <!-- Message dynamique -->
                        <div class="text-center space-y-2">
                            <p class="text-lg font-medium text-gray-800 dark:text-gray-200 animate-pulse">
                                {{ redirectMessage }}
                            </p>
                            <p class="text-sm text-gray-500 dark:text-gray-400">
                                Veuillez patienter quelques instants
                            </p>
                        </div>

                        <!-- Barre de progression -->
                        <div class="w-full bg-gray-200 dark:bg-slate-700 rounded-full h-2 overflow-hidden">
                            <div class="h-full bg-gradient-to-r from-main_color to-main_color_2 animate-progress rounded-full"></div>
                        </div>
                    </div>
                } @else {
                    <!-- État d'erreur -->
                    <div class="text-center space-y-4">
                        <div class="inline-flex items-center justify-center w-16 h-16 bg-red-100 dark:bg-red-900/30 rounded-full">
                            <i class="fas fa-exclamation-triangle text-3xl text-red-600 dark:text-red-400"></i>
                        </div>
                        <div>
                            <p class="text-lg font-medium text-gray-800 dark:text-gray-200 mb-2">
                                Redirection impossible
                            </p>
                            <p class="text-sm text-gray-500 dark:text-gray-400">
                                Vous allez être redirigé vers la page d'accueil...
                            </p>
                        </div>
                    </div>
                }
            </div>
        </div>

        <!-- Footer info -->
        <div class="mt-6 text-center">
            <p class="text-xs text-gray-500 dark:text-gray-400">
                <i class="fas fa-shield-alt mr-1"></i>
                Redirection sécurisée
            </p>
        </div>
    </div>
</div>

<!-- Styles pour l'animation de la barre de progression -->
<style>
@keyframes progress {
    0% {
        width: 0%;
    }
    50% {
        width: 70%;
    }
    100% {
        width: 100%;
    }
}

.animate-progress {
    animation: progress 2s ease-in-out infinite;
}
</style>
